import React, { useEffect, useState } from "react";
import { db, doc, getDoc } from "../boardData";

// OpenWeatherMap key (client-side, already used by the legacy Sidebar).
export const OWM_API_KEY = "50229c69ed23500083e0004c56b83be4";

// Consistent TV-friendly widget chrome. Widgets render their body inside this.
export function WidgetShell({ title, accent, children, padded = true, className = "" }) {
  return (
    <div className={`sb-card ${className}`}>
      {title ? (
        <div className="sb-card-title" style={accent ? { color: accent } : undefined}>
          {title}
        </div>
      ) : null}
      <div className={`sb-card-body${padded ? " padded" : ""}`}>{children}</div>
    </div>
  );
}

export function EmptyState({ icon = "•", label }) {
  return (
    <div className="sb-empty">
      <div className="sb-empty-icon">{icon}</div>
      <div>{label}</div>
    </div>
  );
}

// Resolve agency branding (logo / display name / coordinates) from the various
// places agencies store it, newest path first. Returns {} until resolved.
export function useAgencyInfo(agency) {
  const [info, setInfo] = useState({});
  useEffect(() => {
    let cancelled = false;
    if (!agency) return undefined;
    (async () => {
      const sources = [
        doc(db, "Agencies", agency, "Settings", "Info"),
        doc(db, `${agency} Settings`, "Info"),
        doc(db, "CRM", agency),
      ];
      const merged = {};
      for (const ref of sources) {
        try {
          const snap = await getDoc(ref);
          if (snap.exists()) {
            const d = snap.data();
            merged.name = merged.name || d.name || d.agencyDisplayName;
            merged.logo = merged.logo || d.logo || d.agencyLogo;
            merged.description = merged.description || d.description || d.agencyDescription;
            merged.lat = merged.lat ?? d.lat ?? d.latitude ?? d.coordinates?.latitude;
            merged.lng = merged.lng ?? d.long ?? d.lng ?? d.longitude ?? d.coordinates?.longitude;
          }
        } catch (err) {
          /* keep trying other sources */
        }
      }
      if (!cancelled) setInfo(merged);
    })();
    return () => {
      cancelled = true;
    };
  }, [agency]);
  return info;
}

// Resolve coordinates for weather widgets: board config first, then agency info.
export function useCoordinates(agency, board) {
  const info = useAgencyInfo(agency);
  const cfg = board?.dataSources?.coordinates;
  const lat = cfg?.latitude ?? info.lat ?? null;
  const lng = cfg?.longitude ?? info.lng ?? null;
  return { lat, lng };
}
